import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import { computed, defineComponent, ref } from "vue"; // modules

import CustomersModule from "@/store/modules/customers"; // helpers

import { hideDialog, toggleModalVisible } from "@/utils/vue-helpers/modal";
import { ModalStatus } from "@/constants/modal";
import editPen from "@/assets/images/svg/edit-pen-rectangle.svg";
import BookingModule from "@/store/modules/booking";
export default defineComponent({
  name: "CustomersTable",
  components: {},
  setup: function setup() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var iconStyle, iconContent, iconAlt, table, maxHeight, rows, selectedAllRows, setAllRows, setRows, getCustomersList, onSelect, editCustomer;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              iconStyle = "width: 30px; height: 30px";
              iconContent = editPen;
              iconAlt = "Edit";
              table = ref();
              maxHeight = "50vh";
              rows = [];
              selectedAllRows = false;

              setAllRows = function setAllRows(payload) {
                selectedAllRows = payload;
              }; // eslint-disable-next-line


              setRows = function setRows(payload) {
                rows = payload;
              };

              getCustomersList = computed(function () {
                var list = CustomersModule.getCustomersList;
                var selectedCustomer = CustomersModule.selectedCustomers.find(function (c) {
                  return c.bookingUuid === BookingModule.selectedBookingUUID;
                });
                list.map(function (item) {
                  if (selectedCustomer && selectedCustomer.id === item.id) {
                    var _CustomersModule$sele = CustomersModule.selectedCustomers.reduce(function (previous, current) {
                      if (current.id === item.id) {
                        return current;
                      }
                    }, 0),
                        checkOrder = _CustomersModule$sele.checkOrder;

                    item.checkOrder = checkOrder;
                  } else {
                    item.checkOrder = false;
                  }

                  return item;
                });
                return list;
              });

              onSelect = /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(index, row) {
                  var _getCustomersList$val, country, email, fullName, phone, id, checkOrder, company, address, allergies, language, firstName, lastName, title, zipCode, emailMarketingOrganiser, birthDate, city;

                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          getCustomersList.value[index].checkOrder = !row.checkOrder;

                          if (!getCustomersList.value[index].checkOrder) {
                            _context.next = 7;
                            break;
                          }

                          _getCustomersList$val = getCustomersList.value[index], country = _getCustomersList$val.country, email = _getCustomersList$val.email, fullName = _getCustomersList$val.fullName, phone = _getCustomersList$val.phone, id = _getCustomersList$val.id, checkOrder = _getCustomersList$val.checkOrder, company = _getCustomersList$val.company, address = _getCustomersList$val.address, allergies = _getCustomersList$val.allergies, language = _getCustomersList$val.language, firstName = _getCustomersList$val.firstName, lastName = _getCustomersList$val.lastName, title = _getCustomersList$val.title, zipCode = _getCustomersList$val.zipCode, emailMarketingOrganiser = _getCustomersList$val.emailMarketingOrganiser, birthDate = _getCustomersList$val.birthDate, city = _getCustomersList$val.city; // TODO: Only one customer per booking for now

                          _context.next = 5;
                          return CustomersModule.setSelectedCustomers([{
                            country: country,
                            email: email,
                            fullName: fullName,
                            phone: phone,
                            id: id,
                            checkOrder: checkOrder,
                            bookingUuid: BookingModule.selectedBookingUUID,
                            company: company,
                            address: address,
                            allergies: allergies,
                            language: language,
                            firstName: firstName,
                            lastName: lastName,
                            title: title,
                            zipCode: zipCode,
                            emailMarketingOrganiser: emailMarketingOrganiser,
                            birthDate: birthDate,
                            city: city
                          }]);

                        case 5:
                          _context.next = 9;
                          break;

                        case 7:
                          _context.next = 9;
                          return CustomersModule.setSelectedCustomers([]);

                        case 9:
                          hideDialog();

                        case 10:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function onSelect(_x, _x2) {
                  return _ref.apply(this, arguments);
                };
              }();
              /**
               * Show edit customer popup (it doesn't matter if the customer is assigned to the booking or no)
               */


              editCustomer = function editCustomer(index, row) {
                var _getCustomersList$val2 = getCustomersList.value[index],
                    country = _getCustomersList$val2.country,
                    email = _getCustomersList$val2.email,
                    fullName = _getCustomersList$val2.fullName,
                    phone = _getCustomersList$val2.phone,
                    id = _getCustomersList$val2.id,
                    checkOrder = _getCustomersList$val2.checkOrder,
                    city = _getCustomersList$val2.city,
                    zipCode = _getCustomersList$val2.zipCode,
                    birthDate = _getCustomersList$val2.birthDate,
                    emailMarketingOrganiser = _getCustomersList$val2.emailMarketingOrganiser,
                    company = _getCustomersList$val2.company,
                    address = _getCustomersList$val2.address,
                    allergies = _getCustomersList$val2.allergies,
                    language = _getCustomersList$val2.language,
                    firstName = _getCustomersList$val2.firstName,
                    lastName = _getCustomersList$val2.lastName,
                    title = _getCustomersList$val2.title;
                CustomersModule.setEditedCustomers([{
                  country: country,
                  email: email,
                  fullName: fullName,
                  phone: phone,
                  id: id,
                  checkOrder: checkOrder,
                  city: city,
                  zipCode: zipCode,
                  birthDate: birthDate,
                  emailMarketingOrganiser: emailMarketingOrganiser,
                  company: company,
                  address: address,
                  allergies: allergies,
                  language: language,
                  firstName: firstName,
                  lastName: lastName,
                  title: title
                }]);
                toggleModalVisible(ModalStatus.EditCustomer);
              };

              return _context2.abrupt("return", {
                table: table,
                getCustomersList: getCustomersList,
                maxHeight: maxHeight,
                onSelect: onSelect,
                rows: rows,
                setAllRows: setAllRows,
                selectedAllRows: selectedAllRows,
                setRows: setRows,
                editCustomer: editCustomer,
                toggleModalVisible: toggleModalVisible,
                ModalStatus: ModalStatus,
                iconStyle: iconStyle,
                iconContent: iconContent,
                iconAlt: iconAlt
              });

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }
});